// extracted by mini-css-extract-plugin
export default {"itemText":"services-page_itemText__uX2Vd","content":"services-page_content__WplBx","left":"services-page_left__8F6Th","right":"services-page_right__bbUFH"};